import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      return res.data;
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);
  const setUserFresh = useCallback((u) => { setUser(u); if (u && u.in_academy === undefined) checkAuth(); }, [checkAuth]);

  useEffect(() => {
    // CRITICAL: skip /me during OAuth callback; the callback establishes the session first.
    if (window.location.hash?.includes("session_id=") || window.location.pathname === "/auth/google") {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser: setUserFresh, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
